module.exports = __webpack_public_path__ + "static/media/112.a2312695.jpg";